interface SurveyResponse {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  smsOptIn: "Yes" | "No";
  photos: string[];
  details: string;
}

export const submitToAirtable = async (data: SurveyResponse) => {
  try {
    console.log('Submitting data to serverless function:', data);
    
    const response = await fetch('/api/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Server response:', errorText);
      throw new Error(`Failed to submit form data: ${response.status} ${errorText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error submitting form data:', error);
    throw error;
  }
}; 